import Vue from "vue";
import VueRouter from "vue-router";

import Page from "../components/Page.vue"
import Login from "../pages/Login.vue"
import SubscribePage from "../pages/visitRecord/SubscribePage.vue"
import InvitePage from "../pages/visitRecord/InvitePage.vue"
import VisitorLogPage from "../pages/visitRecord/VisitorLogPage.vue"

import TestPage from "../pages/TestPage.vue"
import OrganizeArch from "../pages/employee/OrganizeArch.vue"
import DepartmentEmployee from "../pages/employee/DepartmentEmployee.vue"
import MemberManage from "../pages/employee/MemberManage.vue"
import UsualVisitor from "../pages/visitor/UsualVisitor.vue"
import BlackVisitor from "../pages/visitor/BlackVisitor.vue"

import AccountInfo from "../pages/personal/AccountInfo.vue"
import AccountManage from "../pages/personal/AccountManage.vue"
import EmptyPage from "@/pages/EmptyPage.vue";
import DeviceMgrImpl from "@/pages/device/VisitorDeviceMgrPage.vue";
import AreaMgrImpl from "@/pages/device/AreaMgrImpl.vue";
import AreaAuthMgrPage from "@/pages/device/AreaAuthMgrPage.vue";
import OperationLog from "@/pages/personal/OperationLog.vue";
import SmsLog from "@/pages/personal/SmsLog.vue";
import VisitorManager from "@/pages/visitor/VisitorManager.vue";
import AppliedRecord from "@/pages/visitJobs/AppliedRecord.vue";
import ArrivedRecord from "@/pages/visitJobs/ArrivedRecord.vue";
import InviteVisitor from "@/pages/visitJobs/InviteVisitor.vue";
import UsualInviteVisitor from "@/pages/visitJobs/UsualInviteVisitor.vue";
import RoleManagerPage from "@/pages/roleManage/RoleManagerPage.vue";
import ManagerRoleViewPage from "@/pages/roleManage/SystemRoleViewPage.vue";
import ApplyingRecord from "@/pages/visitJobs/ApplyingRecord.vue";
import PublicSetting from "@/pages/systemSetting/PublicSetting.vue";
import VisitorMachineSetting from "@/pages/systemSetting/VisitorMachineSetting.vue";
import MobileDeviceSetting from "@/pages/systemSetting/MobileDeviceSetting.vue";
import EntranceGuardSettingPage from "@/pages/systemSetting/EntranceGuardSettingPage.vue";
import VisitorInfoSettingPage from "@/pages/systemSetting/VisitorInfoSettingPage.vue";
import UsualVisitorLogPage from "@/pages/visitRecord/UsualVisitorLogPage.vue";
import EntranceGuardDeviceMgrPage from "@/pages/device/EntranceGuardDeviceMgrPage.vue";
import EntranceGuardLogPage from "@/pages/visitRecord/EntranceGuardLogPage.vue";
import TimerSettingPage from "@/pages/systemSetting/TimerSettingPage.vue";
import SyncLogPage from "@/pages/personal/SyncLogPage.vue";
import InviteVisitorBatch from "@/pages/visitJobs/InviteVisitorBatch.vue";
import EmployeeSettingPage from "@/pages/systemSetting/EmployeeSettingPage.vue";
import WebSettingPage from "@/pages/systemSetting/WebSettingPage.vue";
import BackupLogPage from "@/pages/personal/BackupLogPage.vue";
import GuardSettingPage from "@/pages/guard/GuardSettingPage.vue";
import ProviderVisitor from "@/pages/visitor/ProviderVisitor.vue";
import PageForHome from "@/components/PageForHome.vue";
import OneLeaveMenuPage from "@/components/OneLeaveMenuPage.vue";
import VisitorRegisterPage from "@/pages/guard/VisitorRegisterPage.vue";
import VisitorRecordPage from "@/pages/guard/VisitorRecordPage.vue";
import VisitorApplyPage from "@/pages/guard/VisitorApplyPage.vue";
import InvitePermissionPage from "@/pages/employee/InvitePermissionPage.vue";
import HomePage from "@/HomePage.vue";
import LanguageSettingPage from "@/pages/systemSetting/LanguageSettingPage.vue";
import IntegrationSettingPage from "@/pages/systemSetting/IntegrationSettingPage.vue";

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
            throw error
        }
    })
}
export default new VueRouter({
    routes: [
        {
            path: "/",
            component: HomePage,
            meta: {title: '企业访客管理系统'}
        },
        {path: "/home", name: "home", component: PageForHome, meta: {title: '企业访客管理系统'}},
        {
            path: "/visitRecord",
            component: Page,
            redirect: "/visitRecord/subscribe",
            meta: {title: '企业访客管理系统'},
            children: [
                {
                    name: 'subscribe',
                    path: 'subscribe',
                    component: SubscribePage,
                    meta: {title: '访客预约'},
                },
                {
                    name: 'invite',
                    path: 'invite',
                    component: InvitePage,
                    meta: {title: '邀约访客'},
                },
                {
                    name: 'visitors',
                    path: 'visitors',
                    component: VisitorLogPage,
                    meta: {title: '到访记录'},
                },
                {
                    name: "usualVisitorLog",
                    path: "usualVisitorLog",
                    component: UsualVisitorLogPage,
                    meta: {title: '常访记录'}
                },
                {
                    name: "entranceGuardLog",
                    path: "entranceGuardLog",
                    component: EntranceGuardLogPage,
                    meta: {title: '门禁记录'}
                }
            ]
        },
        {
            path: "/guard",
            component: OneLeaveMenuPage,
            redirect: "/guard/visitorRegister",
            meta: {title: '企业访客管理系统'},
            children: [
                {name: "visitorRegister", path: "visitorRegister", component: VisitorRegisterPage, meta: {title: '访客登记'}},
                {name: 'visitorRecord', path: 'visitorRecord', component: VisitorRecordPage, meta: {title: '访客记录'},},
                {name: 'visitorApply', path: 'visitorApply', component: VisitorApplyPage, meta: {title: '邀约预约'},},
                {name: "GuardSetting", path: "GuardSetting", component: GuardSettingPage, meta: {title: '保安设置'}}
            ]
        },
        {
            path: "/visitor",
            component: Page,
            redirect: "/visitor/organizearch",
            meta: {title: '通信录管理'},
            children: [
                {name: 'visitormanager', path: 'visitormanager', component: VisitorManager, meta: {title: '访客查询'},},
                {name: 'usualvisitor', path: 'usualvisitor', component: UsualVisitor, meta: {title: '常访人员'},},
                {name: 'providerVisitor', path: 'usualVisitor', component: ProviderVisitor, meta: {title: '供应商'},},
                {name: 'blacklist', path: 'blacklist', component: BlackVisitor, meta: {title: '黑名单'},},
            ]
        },
        {
            path: "/employee",
            component: Page,
            redirect: "/manage/organizearch",
            meta: {title: '通信录管理'},
            children: [
                {name: 'organizearch', path: 'organizearch', component: OrganizeArch, meta: {title: '组织架构'},},
                {name: 'departmentemployee', path: 'departmentemployee', component: DepartmentEmployee, meta: {title: '部门员工'},},
                {name: 'membermanage', path: 'membermanage', component: MemberManage, meta: {title: '成员管理'},},
                {name: "invitePermission", path: "invitePermission", component: InvitePermissionPage, meta: {title: '邀请权限'}},
            ]
        },
        {
            path: "/personal",
            component: Page,
            redirect: "/personal/accountinfo",
            meta: {title: '个人中心'},
            children: [
                {name: 'accountinfo', path: 'accountinfo', component: AccountInfo, meta: {title: '账号信息'},},
                {name: 'accountmanage', path: 'accountmanage', component: AccountManage, meta: {title: '账号管理'},},
                {name: 'smsLog', path: 'smsLog', component: SmsLog, meta: {title: '短信记录'},},
                {name: 'operationLog', path: 'operationLog', component: OperationLog, meta: {title: '操作日志'},},
                {name: 'syncLog', path: 'syncLog', component: SyncLogPage, meta: {title: '同步日志'},},
                {name: 'backupLog', path: 'backupLog', component: BackupLogPage, meta: {title: '备份日志'},},
            ]
        },
        {
            path: "/device",
            component: Page,
            redirect: "/device/manager",
            meta: {title: '设备管理'},
            children: [
                {
                    name: 'deviceManager',
                    path: 'manager',
                    component: DeviceMgrImpl,
                    meta: {title: '访客设备'},
                },
                {
                    name: 'deviceArea',
                    path: 'area',
                    component: AreaMgrImpl,
                    meta: {title: '区域管理'},
                },
                {
                    name: 'entranceGuardDevice',
                    path: 'entranceGuardDevice',
                    component: EntranceGuardDeviceMgrPage,
                    meta: {title: '门禁设备'}
                },
                {
                    name: 'areaAuth',
                    path: 'areaAuth',
                    component: AreaAuthMgrPage,
                    meta: {title: '区域授权'}
                }
            ]
        },
        {
            path: "/role",
            component: Page,
            redirect: "/role/roleManage",
            meta: {title: '角色管理'},
            children: [
                {
                    name: 'roleSystem',
                    path: 'roleSystem',
                    component: ManagerRoleViewPage,
                    meta: {title: '系统内置角色'},
                },
                {
                    name: 'roleManage',
                    path: 'roleManage',
                    component: RoleManagerPage,
                    meta: {title: '自定义角色'},
                },
            ]
        },
        {
            path: '/work',
            component: OneLeaveMenuPage,
            redirect: "/work/inviteVisitor",
            meta: {title: '员工邀约'},
            children: [
                {
                    name: 'inviteVisitor',
                    path: 'inviteVisitor',
                    component: InviteVisitor,
                    meta: {title: '邀请访客'},
                },
                {
                    name: 'applyingRecord',
                    path: 'applyingRecord',
                    component: ApplyingRecord,
                    meta: {title: '等待审批'},
                },
                {
                    name: 'appliedRecord',
                    path: 'appliedRecord',
                    component: AppliedRecord,
                    meta: {title: '完成审批'},
                },
                {
                    name: 'historyRecord',
                    path: 'historyRecord',
                    component: ArrivedRecord,
                    meta: {title: '到访记录'},
                },
                {
                    name: 'usualInviteVisitor',
                    path: 'usualInviteVisitor',
                    component: UsualInviteVisitor,
                    meta: {title: '常邀访客'},
                },
                {
                    name: "inviteBatch",
                    path: "inviteBatch",
                    component: InviteVisitorBatch,
                    meta: {title: '批量邀请'}
                }
            ]
        },
        {
            path: "/sysManage",
            component: Page,
            redirect: "/sysManage/publicSetting",
            meta: {title: '系统设置'},
            children: [
                {name: 'publicSetting', path: 'publicSetting', component: PublicSetting, meta: {title: '公共设置'}},
                {name: "employeeSettingPage", path: "employeeSetting", component: EmployeeSettingPage, meta: {title: '员工设置'}},
                {name: 'visitorSetting', path: 'visitorSetting', component: VisitorMachineSetting, meta: {title: '访客设置'}},
                {name: 'mobileSetting', path: 'mobileSetting', component: MobileDeviceSetting, meta: {title: '移动端设置'}},
                {name: 'webSetting', path: 'webSetting', component: WebSettingPage, meta: {title: '网页端设置'}},
                {name: 'entranceGuard', path: 'entranceGuard', component: EntranceGuardSettingPage, meta: {title: '门禁设置'}},
                {name: "visitorInfoSetting", path: "visitorInfoSetting", component: VisitorInfoSettingPage, meta: {title: '访客信息'}},
                {name: "timerSetting", path: "timerSetting", component: TimerSettingPage, meta: {title: '定时器任务'}},
                {name: "integrationSetting", path: "integrationSetting", component: IntegrationSettingPage, meta: {title: '第三方配置'}},
                {name: "languageSetting", path: "languageSetting", component: LanguageSettingPage, meta: {title: '英文版设置'}},
            ]
        },
        {
            name: 'login',
            path: "/login",
            component: Login,
            meta: {title: '登录'},
        },
        {
            name: 'test',
            path: "/test",
            component: TestPage,
            meta: {title: '测试'},
        },
        {
            path: '/empty',
            component: Page,
            redirect: "/empty/empty",
            meta: {title: '空白页'},
            children: [
                {
                    name: 'emptyPage',
                    path: 'empty',
                    component: EmptyPage,
                    meta: {title: '空白页'},
                },
            ]
        },
    ],
    // mode: "history"
})
